import {Component, OnInit} from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import {NbDialogService} from '@nebular/theme';
import {ModalConfirmComponent} from '../../../shared/components/modals/confirm/modal-confirm.component';
import {CompaniesService} from './companies.service';
import {forEach} from 'lodash';

@Component({
  selector: 'app-companies',
  templateUrl: './companies.component.html',
  styleUrls: ['./companies.component.scss']
})
export class CompaniesComponent implements OnInit {
  loading: boolean = false;
  isNew: boolean = false;
  editData: any;
  filterCompany: string = '';
  timer: any;

  tableSettings = {
    mode: 'external',
    noDataMessage: null,
    actions: {
      columnTitle: 'Action'
    },
    add: {
      addButtonContent: '<i class="nb-plus"></i>',
      createButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
    },
    edit: {
      editButtonContent: '<i class="icon-edit app-main-color-fg app-font-size-normal"></i>',
      saveButtonContent: '<i class="icon-check  app-main-color-fg app-font-size-normal"></i>',
      cancelButtonContent: '<i class="icon-cancel app-danger-color-fg app-font-size-normal"></i>',
      confirmSave: true,
    },
    delete: {
      deleteButtonContent: '<i class="icon-delete app-danger-color-fg app-font-size-normal"></i>',
      confirmDelete: true,
    },
    hideSubHeader: true,
    pager: {
      perPage: 24,
    },
    columns: {
      name: {
        title: 'Company Name',
        type: 'string',
        width: '19%',
        sort: false,
      },
      maxUser: {
        title: 'No. of User',
        type: 'number',
        width: '16%',
        sort: false,
      },
      maxHistoricalWell: {
        title: 'Historical Well Data Number',
        type: 'number',
        width: '13%',
        sort: false,
      },
      typeName: {
        title: 'Type',
        type: 'string',
        width: '16%',
        sort: false,
      },
      maxFracSpread: {
        title: 'No. of Frac Spreads',
        type: 'number',
        width: '16%',
        sort: false,
      },
      maxEquipment: {
        title: 'No. of Equipment',
        type: 'number',
        width: '15%',
        sort: false,
      },
    },
  };

  dataSource: any = new LocalDataSource();

  constructor(private dialogService: NbDialogService,
              private companiesService: CompaniesService) {

  }

  ngOnInit() {
    this.loadData();
  }

  onDeleteConfirm(item): void {
    this.dialogService.open(ModalConfirmComponent, {
      context: {
        config: {
          title: 'Delete',
          message: `Are you sure you want to delete <br> <b class="h6">${item.data.name}</b>?`,
          className: 'pop-delete common-page',
          btnTxtConfirm: 'Yes',
          btnTxtCancel: 'No',
          data: item.data,
        }
      }
    }).onClose.subscribe(res => {
      if (res && res.confirm) {
        this.onDelete(res.data);
      }
    });
  }

  loadData(filter?: any) {
    this.loading = true;
    this.companiesService.getListCompany(filter).subscribe(
      (res) => {
        if (res) {
          // sort by id desc
          const data = res.result.items.sort((item) => {
            return -item.id;
          });
          forEach(data, item => {
            if (item.isAllWell) {
              item.maxHistoricalWell = 'All';
            }
          });
          this.dataSource.load(data);
        }
        this.loading = false;
      }, (error) => {
        this.loading = false;
      }
    );
  }

  onAddNew() {
    this.isNew = true;
  }
  onEditData(e) {
    this.editData = e.data;
  }
  onDelete(e) {
    this.companiesService.delete(e.id).subscribe(
      (res) => {
        this.loadData(this.filterCompany);
      });
  }
  onSuccess() {
    this.onCancel();
    this.loadData();
  }
  onCancel() {
    this.filterCompany = '';
    this.isNew = false;
    this.editData = null;
  }

  filterCompanyList() {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.loadData(this.filterCompany);
    }, 1000);
  }

}
